import React, { ChangeEvent, memo, useEffect, useState } from "react";
import { Button } from "components/Buttons";
import { ButtonColorScheme, ButtonType } from "types/ui";

type Props = {
  noteId?: string;
  showModal: boolean;
  onConfirm: (value: string) => void;
  onClose: () => void;
  note?: string;
};
export const NoteDetailsModal = memo(
  ({ showModal, onConfirm, onClose, note = "" }: Props) => {
    const [value, setValue] = useState(note);
    const [disabled, setDisabled] = useState(true);
    const [touched, setTouched] = useState(false);

    const isValid = (text: string) => text?.trim().length > 0;

    const onChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
      const newValue = e.target.value;
      setDisabled(!isValid(newValue));
      setValue(newValue);
      setTouched(true);
    };

    useEffect(() => {
      setValue(note);
      setDisabled(!isValid(note));
      setTouched(false);
    }, [note, showModal]);

    const handleConfirm = () => {
      setDisabled(true);
      onConfirm(value);
    };

    return (
      <>
        {showModal ? (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-auto my-6 mx-auto max-w-3xl w-[500px]">
                <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                  <div className="flex items-start justify-between p-5 border-b border-solid border-blueGray-200 rounded-t">
                    <h2 className="font-semibold">Note content</h2>
                  </div>
                  <form onSubmit={handleConfirm}>
                    <div className="relative px-4 pb-4  flex-auto">
                      <textarea
                        value={value}
                        rows={4}
                        placeholder="Enter your note text"
                        className={`w-full px-4 py-2 border rounded ${
                          touched && !isValid(value)
                            ? "border-red-500 focus:border-red-500 focus:ring-red-500"
                            : "border-gray-300"
                        }`}
                        onChange={onChange}
                      />
                      {touched && !isValid(value) && (
                        <p className="text-red-500 text-sm mt-1">
                          Note content is required
                        </p>
                      )}
                    </div>
                    <div className="flex items-center space-x-2 justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                      <Button
                        title="Cancel"
                        onClick={onClose}
                        type={ButtonType.text}
                        colorScheme={ButtonColorScheme.danger}
                      />
                      <Button
                        title="Confirm"
                        onClick={handleConfirm}
                        colorScheme={
                          disabled
                            ? ButtonColorScheme.disabled
                            : ButtonColorScheme.primary
                        }
                        disabled={disabled}
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black" />
          </>
        ) : null}
      </>
    );
  }
);
